import { render, staticRenderFns } from "./InvoiceHistoryTab.vue?vue&type=template&id=63da4bb4&scoped=true"
import script from "./InvoiceHistoryTab.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHistoryTab.vue?vue&type=style&index=0&id=63da4bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da4bb4",
  null
  
)

export default component.exports